import { PartnerSearchResultType } from '../constants.esm.js';

var esgItems = [
    {
        title: 'Self-attested diverse business',
        icon: 'Partners',
        description: 'Partners who attest to being a 51% diverse-owned business, or a diverse-led business.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'diverseOwn',
                text: 'diverseOwn',
                type: PartnerSearchResultType.DiversityAndInclusion.toString()
            }
        }
    },
    {
        title: 'Certified diverse business',
        icon: 'Partners',
        description: 'Partners who attest to having a third-party diverse business certification.',
        navigateOptions: {
            type: 'marketplacePartnerSuggestion',
            query: {
                value: 'diverseAccred',
                text: 'diverseAccred',
                type: PartnerSearchResultType.DiversityAndInclusion.toString()
            }
        }
    }
];

export { esgItems };
